import styled from 'styled-components';

export const UploadLabel = styled.label`
  border: 1px solid #004037;
  color: #00000;
  border-radius: 8px;
  font-family: 'DM Sans Bold', sans-serif;
  cursor: pointer;
  box-sizing: border-box;
  display: inline-flex;
  align-items: left;
  justify-content: center;
  font-size: 1rem;
  line-height: 1;
  padding: 15px 16px;
  text-align: left;
  text-decoration: none;
  transition: 0.1s;
  white-space: normal;
  -webkit-font-smoothing: antialiased;
  margin: 6px;
  min-width: 200px;
`;
